import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { closeDialog } from 'app/store/actions';
import { useDispatch, useSelector } from 'react-redux';

function NexusDialog(props) {
	const dispatch = useDispatch();
	const state = useSelector(({ nexus }) => nexus.dialog.state);
	const options = useSelector(({ nexus }) => nexus.dialog.options);

	return (
		<Dialog
			open={state}
			onClose={ev => dispatch(closeDialog())}
			aria-labelledby="nexus-dialog-title"
			classes={{
				paper: 'rounded-4'
			}}
			{...options}
		/>
	);
}

export default NexusDialog;
